import React from 'react';
import { Paper, Typography, Divider, Grid, Box } from "@mui/material";

const InvoiceOverView = ({ invoiceData }) => {
  if (!invoiceData) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Invoice Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        
        
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Date Invoiced: {invoiceData.dateInvoiced ? new Date(invoiceData.dateInvoiced).toLocaleDateString() : ''}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        
        
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Po Number: {invoiceData.poNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing Code: {invoiceData.billingCode}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        
        
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing Name: {invoiceData.billingName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing Contact: {invoiceData.billingContact}
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing Address: {invoiceData.billingAddress}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing Address2: {invoiceData.billingAddress2}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing City: {invoiceData.billingCity}
          </Typography>
        </Grid>
      </Grid>

      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing State: {invoiceData.billingState}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing Zip: {invoiceData.billingZip}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing Phone: {invoiceData.billingPhone}
          </Typography>
        </Grid>
      </Grid>

      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing Fax: {invoiceData.billingFax}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Billing Email: {invoiceData.billingEmail}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Invoice Due Date: {invoiceData.invoiceDueDate ? new Date(invoiceData.invoiceDueDate).toLocaleDateString() : ''}
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ mb: 2 }} />
      {/* New Line  */}
      <Grid container spacing={2}>
        
        
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            List Price: {invoiceData.listPrice}
          </Typography>
        </Grid>
      </Grid>

      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Invoice Amount: {invoiceData.invoiceAmount}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Miscellaneous Charges: {invoiceData.miscellaneousCharges}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Adjustable Total: {invoiceData.adjustableTotal}
          </Typography>
        </Grid>
      </Grid>


      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Non Adjustable Total: {invoiceData.nonadjustableTotal}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Discount Percent: {invoiceData.discountPercent}
          </Typography>
        </Grid>
       
      </Grid>
      <Divider sx={{ mb: 2 }} />
      {/* New Line  */}
      <Grid container spacing={2}>
        
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Apply Line Item Discount: {invoiceData.applyLineItemDiscount}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Apply Disc To Misc: {invoiceData.applyDiscToMisc}
          </Typography>
        </Grid>
      </Grid>

      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Deposit: {invoiceData.deposit}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Export Date: {invoiceData.exportDate ? new Date(invoiceData.exportDate).toLocaleDateString() : ''}           
          </Typography>
        </Grid>
        
      </Grid>

      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Invoice Comments: {invoiceData.invcomments}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Discount Amount: {invoiceData.discountAmount}
          </Typography>
        </Grid>
        
      </Grid>
      <Divider sx={{ mb: 2 }} />
      {/* New Line  */}
      <Grid container spacing={2}>
        
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Date Created: {invoiceData.dateCreated ? new Date(invoiceData.dateCreated).toLocaleDateString() : ''}
          </Typography>
        </Grid>
        
      </Grid>
      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Credit Amount: {invoiceData.creditamount}
          </Typography>
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2"  >
            Payment Type: {invoiceData.paymentType}
          </Typography>
        </Grid>
      </Grid>


      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Payment Date: {invoiceData.paymentDate ? new Date(invoiceData.paymentDate).toLocaleDateString() : ''}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Created By: {invoiceData.createdBy}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Invoice Sent: {invoiceData.invoiceSent ? 'Yes' : 'No'}
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ mb: 2 }} />

      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Date Invoice Sent: {invoiceData.dateInvoiceSent ? new Date(invoiceData.dateInvoiceSent).toLocaleDateString() : ''}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Date Invoice Resent: {invoiceData.dateInvoiceResent ? new Date(invoiceData.dateInvoiceResent).toLocaleDateString() : ''}
          </Typography>
        </Grid>
        
      </Grid>


      {/* New Line  */}
     

      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Sync To Qbo: {invoiceData.syncToQbo ? 'Yes' : 'No'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Date Generated: {invoiceData.dateGenerated ? new Date(invoiceData.dateGenerated).toLocaleDateString() : ''}
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ mb: 2 }} />

      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Date Reviewed: {invoiceData.dateReviewed ? new Date(invoiceData.dateReviewed).toLocaleDateString() : ''}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Generate dBy: {invoiceData.generatedBy}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Reviewed By: {invoiceData.reviewedBy}
          </Typography>
        </Grid>
      </Grid>


      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Invoice Status: {invoiceData.invoiceStatus}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Date Sent: {invoiceData.dateSent ? new Date(invoiceData.dateSent).toLocaleDateString() : ''}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Correction Comments: {invoiceData.correctionComments}
          </Typography>
        </Grid>
      </Grid>


      {/* New Line  */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Needs Correction Date: {invoiceData.needsCorrectionDate ? new Date(invoiceData.needsCorrectionDate).toLocaleDateString() : ''}
          </Typography>
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Stripe Id: {invoiceData.stripeId}
          </Typography>
        </Grid>
      </Grid>

    </Paper>
  );
};

export default InvoiceOverView;
